import React, { useState, useEffect, Fragment } from 'react';
import styled from '@emotion/styled';

import { Theme } from 'ui_system/theme';
import { ReactModal } from 'ui_system/modals/ReactModal';
import PasswordValidator from 'ui_system/forms/PasswordValidator';

import {
  passwordValidationRules,
  isValidPassword,
} from 'data_system/token_auth/utils';

import { t } from 'services/translation';
import { titleize } from 'lib/string_utils';
import { Input, Form, Error, InputSection } from './styles_auth';
import { Button } from './elements/Button';

export const Label = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
  text-transform: capitalize;
`;

const Heading = styled.h1`
  padding-bottom: 16px;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  text-transform: capitalize;

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    padding-bottom: 0;
    padding-top: 16px;
    font-size: 18px;
  }
`;

const ChangePasswordModalContent = ({
  onSubmit,
  isSubmitting,
  submitError,
}) => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [error, setError] = useState(null);

  const passwordRules = passwordValidationRules(password);
  const isValid = currentPassword && isValidPassword(password, passwordRules);

  useEffect(() => {
    if (error && password === passwordConfirmation) setError(null);
  }, [password, passwordConfirmation]);

  const submitForm = (e) => {
    e.preventDefault();

    // Prevent form submission and show error if passwords do not match
    if (password !== passwordConfirmation) {
      setError(t('PASSWORDS_DO_NOT_MATCH'));
      return;
    }

    onSubmit({
      currentPassword,
      password,
      passwordConfirmation,
    });
  };

  return (
    <Fragment>
      <Heading>{t('CHANGE_PASSWORD')}</Heading>
      <Form onSubmit={submitForm}>
        <Label>{t('CURRENT_PASSWORD')}</Label>
        <InputSection>
          <Input
            onChange={(e) => setCurrentPassword(e.target.value)}
            type="password"
            value={currentPassword}
            placeholder={t('ENTER_CURRENT_PASSWORD')}
            autoComplete="current-password"
          />
          {submitError ? <Error>{submitError}</Error> : null}
        </InputSection>
        <Label>{t('NEW_PASSWORD')}</Label>
        <InputSection>
          <Input
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            value={password}
            placeholder={t('CHOOSE_NEW_PASSWORD')}
            autoComplete="new-password"
          />
        </InputSection>
        <PasswordValidator password={password} passwordRules={passwordRules} />
        <Label>{titleize(t('CONFIRM_NEW_PASSWORD'))}</Label>
        <InputSection>
          <Input
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            type="password"
            value={passwordConfirmation}
            placeholder={t('CONFIRM_NEW_PASSWORD')}
            autoComplete="new-password"
          />
          {error ? <Error>{error}</Error> : null}
        </InputSection>
        <Button
          disabled={isSubmitting}
          faded={!isValid}
          text={t('UPDATE_PASSWORD')}
        />
      </Form>
    </Fragment>
  );
};

const CPM = ReactModal(ChangePasswordModalContent);
export const ChangePasswordModal = styled(CPM)`
  @media (min-width: ${Theme.mobile.phoneWidth}px) {
    width: 480px;
    padding-bottom: 0px;
  }
`;
